import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/Intrinsics.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  get_rem2p56fiaxda5jo as get_rem,
  get_rem14pbkv8p42gid as get_rem_0,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/models/data.commonHtml.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  sizeConstraints2hv7x4j4qpd36 as sizeConstraints,
  get_scrolling27q1yr4ng0cx8 as get_scrolling,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.mjs';
import { TextArea6va0jt1dj0tc as TextArea } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextArea.commonHtml.mjs';
import { suspendOrReturn49pspzlx5djv as suspendOrReturn } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import {
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForFunctionReferencen3g5fpj34t8u as initMetadataForFunctionReference,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { charSequenceLength3278n89t01tmv as charSequenceLength } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import {
  PrimaryButtonSemantic_getInstance2oopjxbt9oc9b as PrimaryButtonSemantic_getInstance,
  get_textButtonybbt8y3eu5hx as get_textButton,
  specCenteredText1zemopd0g3rsf as specCenteredText,
  get_tertiaryButton1h22y4lorv47t as get_tertiaryButton,
} from '../theming/buttons.mjs';
import { Signal1973xs1vkmdcb as Signal } from '../../../../../reactive/com/lightningkite/reactive/core/signals.mjs';
import { Companion_getInstance2xbytizsyx2ps as Companion_getInstance } from '../../../../../kiteui-library/com/lightningkite/kiteui/ViewWrapper.mjs';
import { DismissBackground1nezyx9ss0e1b as DismissBackground } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/DismissBackground.commonHtml.mjs';
import { get_AppDimensions1ckwvsuun6046 as get_AppDimensions } from '../components/nav/AppDimensions.mjs';
import {
  get_centered1xfu6or5nc0lq as get_centered,
  get_atTopCenter1v6irntzl0tu6 as get_atTopCenter,
  get_atEnd1cw5d2zgug26 as get_atEnd,
  get_expanding10cuv3ua9vajx as get_expanding,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/views/helpers.mjs';
import {
  Frame1e7t2kcdb3wu7 as Frame,
  RowOrCol3a33s3yce2tuv as RowOrCol,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/ContainingView.commonHtml.mjs';
import { Edges2jf5wl855ambv as Edges } from '../../../../../kiteui-library/com/lightningkite/kiteui/models/Rect.mjs';
import {
  DialogSemantic_getInstance3cqn6ufjbbrs2 as DialogSemantic_getInstance,
  FieldSemantic_getInstance2sngfoinp7a00 as FieldSemantic_getInstance,
  SubtextSemantic_getInstance3oi0npjp97gok as SubtextSemantic_getInstance,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/models/Theme.mjs';
import {
  title1nssp3ryhwuqj as title,
  body3i5t0n7zprpqb as body,
  SmallBodySemantic_getInstance13vsg4635cu56 as SmallBodySemantic_getInstance,
  bodyBold2czwdzwknab0k as bodyBold,
} from '../theming/Titles.mjs';
import { TextViewe6rp77b08kos as TextView } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextView.commonHtml.mjs';
import { KMutableProperty025txtn5b59pq1 as KMutableProperty0 } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { reactiveScope1fcalsbdr0hgb as reactiveScope } from '../../../../../reactive/com/lightningkite/reactive/context/ReactiveContext.mjs';
import { errorTextv58wi1t0me7u as errorText } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/l2/shortstuff.mjs';
import { AppColors_getInstance3ty7139j9u8g2 as AppColors_getInstance } from '../theming/AppColors.mjs';
import { colored3y8uibz1hk46 as colored } from '../theming/colorManagement.mjs';
import { Button263cw152yl80e as Button } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.commonHtml.mjs';
import { onClick25t27tv78ic5x as onClick } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.mjs';
import {
  get_titlelss9nf4gv6ut as get_title,
  Page1o437w9xuocrm as Page,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/navigation/Page.mjs';
import {
  protoOf180f3jzyo7rfj as protoOf,
  toString1pkumu07cwy4m as toString,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  hashCodeq5arwsb9dgti as hashCode,
  equals2au1ep9vhcato as equals,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { get_session9cytjmfbg8nd as get_session } from '../../sdk/UserSession.mjs';
import { await1kke5zj2piplv as await_0 } from '../../../../../reactive/com/lightningkite/reactive/context/DependencyChangeListener.mjs';
import { requestFiles2wr6y980phloh as requestFiles } from '../../../../../kiteui-library/com/lightningkite/kiteui/ExternalServices.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/Iterables.mjs';
import {
  LocalFileyitm5ua4ch17 as LocalFile,
  FileDataw8niis0ucpno as FileData,
} from '../components/files/attachmentFilePreview.mjs';
import { asyncz02dsa2nb2zt as async } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Builders.common.mjs';
import { awaitAll3u8r91uegk3sa as awaitAll } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Await.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { CoroutineScopefcb5f5dwqcas as CoroutineScope } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineScope.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { ReactiveMutableList2gg4x024enrbf as ReactiveMutableList } from '../../../../../reactive/com/lightningkite/reactive/core/ReactiveMutableList.mjs';
import { Spaceoq5xo9lsieqc as Space } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Space.commonHtml.mjs';
import { get_viewIsWide3s4g60a9e0192 as get_viewIsWide } from '../components/nav/crowpay.mjs';
import { shownDefaultFalse3hpz4awymyomc as shownDefaultFalse } from '../../utils/utils.mjs';
import { fileCarousely0kamh1gns47 as fileCarousel } from '../components/files/fileManager.mjs';
import { label287uhiq3m9m4z as label2 } from '../components/label2.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
function *_generator_invoke__zhh2q8($this, $completion) {
  var tmp = $this.uil_1.gia($this.vil_1, false, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_0($this, $completion) {
  var tmp = $this.wil_1.gia($this.xil_1, false, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_1($this, $completion) {
  var tmp = $this.yil_1.gia($this.zil_1, true, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function textInput$input(_this__u8e3s4, this$0) {
  var tmp = sizeConstraints(_this__u8e3s4, VOID, VOID, get_rem(8));
  // Inline function 'com.lightningkite.kiteui.views.direct.textArea' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (TextArea())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.cbb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.ebb(p, view);
  view.tcl(this$0.ngs_1);
  view.xah(view.qcl_1, this$0.qgs_1);
  _this__u8e3s4.fbb(p, view);
  return _this__u8e3s4.jbb(tmp, view);
}
var BaseTextInputDialog$dialogCol$slambdaClass;
function BaseTextInputDialog$dialogCol$slambda() {
  if (BaseTextInputDialog$dialogCol$slambdaClass === VOID) {
    class $ {
      constructor(this$0, $$this$dismissBackground) {
        this.uil_1 = this$0;
        this.vil_1 = $$this$dismissBackground;
      }
      sao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    BaseTextInputDialog$dialogCol$slambdaClass = $;
  }
  return BaseTextInputDialog$dialogCol$slambdaClass;
}
function BaseTextInputDialog$dialogCol$slambda_0(this$0, $$this$dismissBackground) {
  var i = new (BaseTextInputDialog$dialogCol$slambda())(this$0, $$this$dismissBackground);
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
function TextView$_get_content_$ref_4pzcwl(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.tb5_1.jb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.tb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.fbu(tmp_0);
    return Unit_instance;
  };
}
var BaseTextInputDialog$dismissButton$slambdaClass;
function BaseTextInputDialog$dismissButton$slambda() {
  if (BaseTextInputDialog$dismissButton$slambdaClass === VOID) {
    class $ {
      constructor(this$0, $$this$button) {
        this.wil_1 = this$0;
        this.xil_1 = $$this$button;
      }
      sao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_0.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    BaseTextInputDialog$dismissButton$slambdaClass = $;
  }
  return BaseTextInputDialog$dismissButton$slambdaClass;
}
function BaseTextInputDialog$dismissButton$slambda_0(this$0, $$this$button) {
  var i = new (BaseTextInputDialog$dismissButton$slambda())(this$0, $$this$button);
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
function Button$_get_enabled_$ref_61t7nx(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.Button.enabled' call
    // Inline function 'com.lightningkite.kiteui.views.disabled' call
    var tmp = p0.tb5_1.zb3_1.ib7_1.disabled;
    return !(((!(tmp == null) ? typeof tmp === 'boolean' : false) ? tmp : null) === true);
  };
}
function Button$_set_enabled_$ref_o8kynz(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.Button.enabled' call
    var tmp0 = p0.tb5_1.zb3_1;
    // Inline function 'com.lightningkite.kiteui.views.disabled' call
    var value = !_this__u8e3s4;
    tmp0.ib7_1.disabled = value;
    return Unit_instance;
  };
}
var BaseTextInputDialog$submitButton$slambdaClass;
function BaseTextInputDialog$submitButton$slambda() {
  if (BaseTextInputDialog$submitButton$slambdaClass === VOID) {
    class $ {
      constructor(this$0, $$this$button) {
        this.yil_1 = this$0;
        this.zil_1 = $$this$button;
      }
      sao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_1.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    BaseTextInputDialog$submitButton$slambdaClass = $;
  }
  return BaseTextInputDialog$submitButton$slambdaClass;
}
function BaseTextInputDialog$submitButton$slambda_0(this$0, $$this$button) {
  var i = new (BaseTextInputDialog$submitButton$slambda())(this$0, $$this$button);
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
var BaseTextInputDialogClass;
function BaseTextInputDialog() {
  if (BaseTextInputDialogClass === VOID) {
    class $ {
      constructor(header, message, confirmationText, confirmationTheme, minChars, hint, dismissText, scroll) {
        confirmationTheme = confirmationTheme === VOID ? PrimaryButtonSemantic_getInstance() : confirmationTheme;
        minChars = minChars === VOID ? 0 : minChars;
        hint = hint === VOID ? minChars > 0 ? 'Min ' + minChars + ' characters' : '' : hint;
        dismissText = dismissText === VOID ? 'Go Back' : dismissText;
        scroll = scroll === VOID ? true : scroll;
        this.igs_1 = header;
        this.jgs_1 = message;
        this.kgs_1 = confirmationText;
        this.lgs_1 = confirmationTheme;
        this.mgs_1 = minChars;
        this.ngs_1 = hint;
        this.ogs_1 = dismissText;
        this.pgs_1 = scroll;
        this.qgs_1 = Signal().fak('');
      }
      lia(_this__u8e3s4, contents) {
        var tmp = this.pgs_1 ? get_scrolling(_this__u8e3s4) : Companion_getInstance();
        // Inline function 'com.lightningkite.kiteui.views.direct.dismissBackground' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view = new (DismissBackground())(_this__u8e3s4.pc());
        var tmp0_elvis_lhs = _this__u8e3s4.cbb_1;
        var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
        _this__u8e3s4.ebb(p, view);
        view.eba(get_AppDimensions().wg1_1);
        view.tbo(BaseTextInputDialog$dialogCol$slambda_0(this, view));
        var tmp_0 = this.pgs_1 ? get_atTopCenter(view) : get_centered(view);
        // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_0 = new (Frame())(view.pc());
        var tmp0_elvis_lhs_0 = view.cbb_1;
        var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
        view.ebb(p_0, view_0);
        var tmp0_vertical = get_rem(5);
        var tmp1_horizontal = get_rem(0);
        view_0.hba(Edges().cd0(tmp1_horizontal, tmp0_vertical));
        view_0.cb9(true);
        var tmp_1 = view_0.ibb(view_0.ibb(get_centered(view_0), view_0.hbb(DialogSemantic_getInstance())), sizeConstraints(view_0, VOID, VOID, VOID, VOID, VOID, get_rem(45)));
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_1 = new (RowOrCol())(view_0.pc());
        var tmp0_elvis_lhs_1 = view_0.cbb_1;
        var p_1 = tmp0_elvis_lhs_1 == null ? view_0 : tmp0_elvis_lhs_1;
        view_0.ebb(p_1, view_1);
        view_1.xbm(true);
        contents(view_1);
        view_0.fbb(p_1, view_1);
        view_0.jbb(tmp_1, view_1);
        view.fbb(p_0, view_0);
        view.jbb(tmp_0, view_0);
        _this__u8e3s4.fbb(p, view);
        return _this__u8e3s4.jbb(tmp, view);
      }
      iia(_this__u8e3s4) {
        return title(_this__u8e3s4, this.igs_1);
      }
      jia(_this__u8e3s4) {
        return body(_this__u8e3s4, this.jgs_1);
      }
      mia(_this__u8e3s4) {
        var tmp = get_atEnd(_this__u8e3s4);
        // Inline function 'com.crowpay.views.theming.smallBody' call
        // Inline function 'com.lightningkite.kiteui.views.direct.text' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view = new (TextView())(_this__u8e3s4.pc());
        var tmp0_elvis_lhs = _this__u8e3s4.cbb_1;
        var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
        _this__u8e3s4.ebb(p, view);
        view.jba(view.ob6_1.ybe(SmallBodySemantic_getInstance()));
        var tmp_0 = KMutableProperty0();
        var tmp_1 = TextView$_get_content_$ref_4pzcwl(view);
        // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
        var this_0 = getPropertyCallableRef('content', 0, tmp_0, tmp_1, TextView$_set_content_$ref_pketfb(view));
        reactiveScope(view, ($this$reactiveScope) => {
          // Inline function 'kotlin.takeIf' call
          var this_1 = this.mgs_1 - $this$reactiveScope.baj(this.qgs_1).length | 0;
          var tmp;
          if (this_1 > 0) {
            tmp = this_1;
          } else {
            tmp = null;
          }
          var tmp0_safe_receiver = tmp;
          var tmp_0;
          if (tmp0_safe_receiver == null) {
            tmp_0 = null;
          } else {
            // Inline function 'kotlin.let' call
            tmp_0 = '(' + tmp0_safe_receiver + ') more characters required';
          }
          var tmp1_elvis_lhs = tmp_0;
          var tmp$ret$4 = tmp1_elvis_lhs == null ? '' : tmp1_elvis_lhs;
          this_0.set(tmp$ret$4);
          return Unit_instance;
        });
        _this__u8e3s4.fbb(p, view);
        return _this__u8e3s4.jbb(tmp, view);
      }
      kia(_this__u8e3s4) {
        var tmp;
        if (this.mgs_1 > 0) {
          // Inline function 'com.lightningkite.kiteui.views.direct.col' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view = new (RowOrCol())(_this__u8e3s4.pc());
          var tmp0_elvis_lhs = _this__u8e3s4.cbb_1;
          var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
          _this__u8e3s4.ebb(p, view);
          view.xbm(true);
          view.zb8(get_rem_0(0.1));
          // Inline function 'com.crowpay.views.components.requiredField' call
          // Inline function 'com.lightningkite.kiteui.views.direct.col' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_0 = new (RowOrCol())(view.pc());
          var tmp0_elvis_lhs_0 = view.cbb_1;
          var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
          view.ebb(p_0, view_0);
          view_0.xbm(true);
          view_0.zb8(get_AppDimensions().ng2_1);
          // Inline function 'com.lightningkite.kiteui.views.direct.row' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_1 = new (RowOrCol())(view_0.pc());
          var tmp0_elvis_lhs_1 = view_0.cbb_1;
          var p_1 = tmp0_elvis_lhs_1 == null ? view_0 : tmp0_elvis_lhs_1;
          view_0.ebb(p_1, view_1);
          view_1.xbm(false);
          view_1.zb8(get_AppDimensions().pg2_1);
          view_1.jbb(get_centered(view_1), bodyBold(view_1, 'Message'));
          view_1.jbb(colored(view_1, AppColors_getInstance().hfz_1.xg9_1), bodyBold(view_1, '*'));
          view_0.fbb(p_1, view_1);
          // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
          var tmp_0 = view_0.hbb(FieldSemantic_getInstance());
          var tmp$ret$5 = textInput$input(view_0, this);
          view_0.jbb(tmp_0, tmp$ret$5);
          view.fbb(p_0, view_0);
          this.mia(view);
          _this__u8e3s4.fbb(p, view);
          tmp = view;
        } else {
          // Inline function 'com.crowpay.views.components.field2' call
          // Inline function 'com.lightningkite.kiteui.views.direct.col' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_2 = new (RowOrCol())(_this__u8e3s4.pc());
          var tmp0_elvis_lhs_2 = _this__u8e3s4.cbb_1;
          var p_2 = tmp0_elvis_lhs_2 == null ? _this__u8e3s4 : tmp0_elvis_lhs_2;
          _this__u8e3s4.ebb(p_2, view_2);
          view_2.xbm(true);
          view_2.zb8(get_AppDimensions().ng2_1);
          bodyBold(view_2, 'Message');
          // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
          var tmp_1 = view_2.hbb(FieldSemantic_getInstance());
          var tmp$ret$16 = textInput$input(view_2, this);
          view_2.jbb(tmp_1, tmp$ret$16);
          view_2.jbb(view_2.hbb(SubtextSemantic_getInstance()), errorText(view_2));
          _this__u8e3s4.fbb(p_2, view_2);
          tmp = view_2;
        }
        return tmp;
      }
      nia(_this__u8e3s4) {
        var tmp = get_textButton(_this__u8e3s4);
        // Inline function 'com.lightningkite.kiteui.views.direct.button' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view = new (Button())(_this__u8e3s4.pc());
        var tmp0_elvis_lhs = _this__u8e3s4.cbb_1;
        var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
        _this__u8e3s4.ebb(p, view);
        view.jbb(get_centered(view), body(view, this.ogs_1));
        onClick(view, this.ogs_1, VOID, BaseTextInputDialog$dismissButton$slambda_0(this, view));
        _this__u8e3s4.fbb(p, view);
        return _this__u8e3s4.jbb(tmp, view);
      }
      hia(_this__u8e3s4) {
        var tmp = _this__u8e3s4.hbb(this.lgs_1);
        // Inline function 'com.lightningkite.kiteui.views.direct.button' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view = new (Button())(_this__u8e3s4.pc());
        var tmp0_elvis_lhs = _this__u8e3s4.cbb_1;
        var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
        _this__u8e3s4.ebb(p, view);
        if (this.mgs_1 > 0) {
          var tmp_0 = KMutableProperty0();
          var tmp_1 = Button$_get_enabled_$ref_61t7nx(view);
          // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
          var this_0 = getPropertyCallableRef('enabled', 0, tmp_0, tmp_1, Button$_set_enabled_$ref_o8kynz(view));
          reactiveScope(view, ($this$reactiveScope) => {
            var tmp$ret$0 = $this$reactiveScope.baj(this.qgs_1).length >= this.mgs_1;
            this_0.set(tmp$ret$0);
            return Unit_instance;
          });
        }
        specCenteredText(view, this.kgs_1);
        onClick(view, this.kgs_1, VOID, BaseTextInputDialog$submitButton$slambda_0(this, view));
        _this__u8e3s4.fbb(p, view);
        return _this__u8e3s4.jbb(tmp, view);
      }
      ci5(_this__u8e3s4) {
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view = new (RowOrCol())(_this__u8e3s4.pc());
        var tmp0_elvis_lhs = _this__u8e3s4.cbb_1;
        var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
        _this__u8e3s4.ebb(p, view);
        view.xbm(false);
        this.hia(view);
        this.nia(view);
        _this__u8e3s4.fbb(p, view);
        return view;
      }
      ud6(_this__u8e3s4) {
        return this.lia(_this__u8e3s4, ($this$dialogCol) => {
          this.iia($this$dialogCol);
          this.jia($this$dialogCol);
          this.kia($this$dialogCol);
          this.ci5($this$dialogCol);
          return Unit_instance;
        });
      }
    }
    protoOf($).ucv = get_title;
    initMetadataForClass($, 'BaseTextInputDialog', VOID, VOID, [Page()], [2]);
    BaseTextInputDialogClass = $;
  }
  return BaseTextInputDialogClass;
}
function *_generator_submit__rtm368($this, _this__u8e3s4, confirmed, $completion) {
  if (confirmed) {
    var tmp = $this.jim_1($this.qgs_1.f2(), $completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
  } else {
    var tmp_0 = $this.jim_1(null, $completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
  }
  return Unit_instance;
}
var TextInputDialogClass;
function TextInputDialog() {
  if (TextInputDialogClass === VOID) {
    class $ extends BaseTextInputDialog() {
      constructor(header, message, confirmationText, confirmationTheme, minChars, hint, onSubmit) {
        confirmationTheme = confirmationTheme === VOID ? PrimaryButtonSemantic_getInstance() : confirmationTheme;
        minChars = minChars === VOID ? 0 : minChars;
        hint = hint === VOID ? minChars > 0 ? 'Min ' + minChars + ' characters' : '' : hint;
        super(header, message, confirmationText, confirmationTheme, minChars, hint);
        this.jim_1 = onSubmit;
      }
      gia(_this__u8e3s4, confirmed, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_submit__rtm368.bind(VOID, this, _this__u8e3s4, confirmed), $completion);
      }
    }
    initMetadataForClass($, 'TextInputDialog', VOID, VOID, VOID, [2]);
    TextInputDialogClass = $;
  }
  return TextInputDialogClass;
}
function *_generator_invoke__zhh2q8_2($this, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = get_session();
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp$ret$0 = tmp;
  return LiveApi2$Api2ProjectLive$uploadFileForRequest$ref_0(tmp$ret$0.tfw().pfg_1);
}
var LiveApi2$Api2ProjectLive$uploadFileForRequest$refClass;
function LiveApi2$Api2ProjectLive$uploadFileForRequest$ref() {
  if (LiveApi2$Api2ProjectLive$uploadFileForRequest$refClass === VOID) {
    class $ {
      constructor(p0) {
        this.kim_1 = p0;
      }
      sao($completion) {
        return this.kim_1.jfi($completion);
      }
    }
    initMetadataForFunctionReference($, VOID, VOID, [0]);
    LiveApi2$Api2ProjectLive$uploadFileForRequest$refClass = $;
  }
  return LiveApi2$Api2ProjectLive$uploadFileForRequest$refClass;
}
function LiveApi2$Api2ProjectLive$uploadFileForRequest$ref_0(p0) {
  var i = new (LiveApi2$Api2ProjectLive$uploadFileForRequest$ref())(p0);
  var l = ($completion) => i.sao($completion);
  l.callableName = 'uploadFileForRequest';
  l.$arity = 0;
  return l;
}
function *_generator_invoke__zhh2q8_3($this, $this$async, $completion) {
  var tmp = $this.zim_1.uim_1($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp_0 = $this.yim_1.xgb(tmp, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_4($this, $completion) {
  var tmp = requestFiles($this.ain_1.pc(), VOID, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  // Inline function 'kotlin.collections.map' call
  var this_0 = tmp;
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList().u(collectionSizeOrDefault(this_0, 10));
  var _iterator__ex2g4s = this_0.m1();
  while (_iterator__ex2g4s.n1()) {
    var item = _iterator__ex2g4s.o1();
    var preview = new (LocalFile())(item);
    $this.bin_1.xim_1.lam(new (FileData())(VOID, Signal().fak(''), preview, preview));
    var tmp$ret$0 = async($this.ain_1, VOID, VOID, TextAndFileInputDialog$attachmentButton$slambda$slambda_0(preview, $this.bin_1));
    destination.v(tmp$ret$0);
  }
  var tmp_0 = awaitAll(destination, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  return Unit_instance;
}
var TextAndFileInputDialog$attachmentButton$slambda$slambdaClass;
function TextAndFileInputDialog$attachmentButton$slambda$slambda() {
  if (TextAndFileInputDialog$attachmentButton$slambda$slambdaClass === VOID) {
    class $ {
      constructor($preview, this$0) {
        this.yim_1 = $preview;
        this.zim_1 = this$0;
      }
      wah($this$async, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_3.bind(VOID, this, $this$async), $completion);
      }
      s2(p1, $completion) {
        return this.wah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    TextAndFileInputDialog$attachmentButton$slambda$slambdaClass = $;
  }
  return TextAndFileInputDialog$attachmentButton$slambda$slambdaClass;
}
function TextAndFileInputDialog$attachmentButton$slambda$slambda_0($preview, this$0) {
  var i = new (TextAndFileInputDialog$attachmentButton$slambda$slambda())($preview, this$0);
  var l = ($this$async, $completion) => i.wah($this$async, $completion);
  l.$arity = 1;
  return l;
}
var SubmissionClass;
function Submission() {
  if (SubmissionClass === VOID) {
    class $ {
      constructor(message, files) {
        this.xh2_1 = message;
        this.yh2_1 = files;
      }
      toString() {
        return 'Submission(message=' + this.xh2_1 + ', files=' + toString(this.yh2_1) + ')';
      }
      hashCode() {
        var result = getStringHashCode(this.xh2_1);
        result = imul(result, 31) + hashCode(this.yh2_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Submission()))
          return false;
        if (!(this.xh2_1 === other.xh2_1))
          return false;
        if (!equals(this.yh2_1, other.yh2_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'Submission');
    SubmissionClass = $;
  }
  return SubmissionClass;
}
function *_generator_submit__rtm368_0($this, _this__u8e3s4, confirmed, $completion) {
  if (confirmed) {
    var tmp = $this.wim_1(_this__u8e3s4, new (Submission())($this.qgs_1.f2(), $this.xim_1), $completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
  } else {
    var tmp_0 = $this.wim_1(_this__u8e3s4, null, $completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
  }
  return Unit_instance;
}
var TextAndFileInputDialog$_init_$slambda_4rv9moClass;
function TextAndFileInputDialog$_init_$slambda_4rv9mo() {
  if (TextAndFileInputDialog$_init_$slambda_4rv9moClass === VOID) {
    class $ {
      sao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_2.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    TextAndFileInputDialog$_init_$slambda_4rv9moClass = $;
  }
  return TextAndFileInputDialog$_init_$slambda_4rv9moClass;
}
function TextAndFileInputDialog$_init_$slambda_4rv9mo_0() {
  var i = new (TextAndFileInputDialog$_init_$slambda_4rv9mo())();
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
var TextAndFileInputDialog$attachmentButton$slambdaClass;
function TextAndFileInputDialog$attachmentButton$slambda() {
  if (TextAndFileInputDialog$attachmentButton$slambdaClass === VOID) {
    class $ {
      constructor($$this$button, this$0) {
        this.ain_1 = $$this$button;
        this.bin_1 = this$0;
      }
      sao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_4.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    TextAndFileInputDialog$attachmentButton$slambdaClass = $;
  }
  return TextAndFileInputDialog$attachmentButton$slambdaClass;
}
function TextAndFileInputDialog$attachmentButton$slambda_0($$this$button, this$0) {
  var i = new (TextAndFileInputDialog$attachmentButton$slambda())($$this$button, this$0);
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
var TextAndFileInputDialogClass;
function TextAndFileInputDialog() {
  if (TextAndFileInputDialogClass === VOID) {
    class $ extends BaseTextInputDialog() {
      constructor(header, message, confirmationText, confirmationTheme, minChars, hint, uploader, extraContent, onSubmit) {
        confirmationTheme = confirmationTheme === VOID ? PrimaryButtonSemantic_getInstance() : confirmationTheme;
        minChars = minChars === VOID ? 0 : minChars;
        hint = hint === VOID ? minChars > 0 ? 'Min ' + minChars + ' characters' : '' : hint;
        var tmp;
        if (uploader === VOID) {
          tmp = TextAndFileInputDialog$_init_$slambda_4rv9mo_0();
        } else {
          tmp = uploader;
        }
        uploader = tmp;
        extraContent = extraContent === VOID ? null : extraContent;
        super(header, message, confirmationText, confirmationTheme, minChars, hint);
        this.uim_1 = uploader;
        this.vim_1 = extraContent;
        this.wim_1 = onSubmit;
        this.xim_1 = ReactiveMutableList().tam();
      }
      gia(_this__u8e3s4, confirmed, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_submit__rtm368_0.bind(VOID, this, _this__u8e3s4, confirmed), $completion);
      }
      nhr(_this__u8e3s4) {
        var tmp = get_tertiaryButton(_this__u8e3s4);
        // Inline function 'com.lightningkite.kiteui.views.direct.button' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view = new (Button())(_this__u8e3s4.pc());
        var tmp0_elvis_lhs = _this__u8e3s4.cbb_1;
        var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
        _this__u8e3s4.ebb(p, view);
        specCenteredText(view, '+ Attachment');
        onClick(view, 'Upload Attachments', VOID, TextAndFileInputDialog$attachmentButton$slambda_0(view, this));
        _this__u8e3s4.fbb(p, view);
        return _this__u8e3s4.jbb(tmp, view);
      }
      ci5(_this__u8e3s4) {
        var tmp;
        if (get_viewIsWide(_this__u8e3s4)) {
          // Inline function 'com.lightningkite.kiteui.views.direct.row' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view = new (RowOrCol())(_this__u8e3s4.pc());
          var tmp0_elvis_lhs = _this__u8e3s4.cbb_1;
          var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
          _this__u8e3s4.ebb(p, view);
          view.xbm(false);
          this.nhr(view);
          var tmp_0 = get_expanding(view);
          // Inline function 'com.lightningkite.kiteui.views.direct.space' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_0 = new (Space())(view.pc());
          var tmp0_elvis_lhs_0 = view.cbb_1;
          var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
          view.ebb(p_0, view_0);
          view.fbb(p_0, view_0);
          view.jbb(tmp_0, view_0);
          this.nia(view);
          this.hia(view);
          _this__u8e3s4.fbb(p, view);
          tmp = view;
        } else {
          // Inline function 'com.lightningkite.kiteui.views.direct.col' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_1 = new (RowOrCol())(_this__u8e3s4.pc());
          var tmp0_elvis_lhs_1 = _this__u8e3s4.cbb_1;
          var p_1 = tmp0_elvis_lhs_1 == null ? _this__u8e3s4 : tmp0_elvis_lhs_1;
          _this__u8e3s4.ebb(p_1, view_1);
          view_1.xbm(true);
          this.nhr(view_1);
          // Inline function 'com.lightningkite.kiteui.views.direct.row' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_2 = new (RowOrCol())(view_1.pc());
          var tmp0_elvis_lhs_2 = view_1.cbb_1;
          var p_2 = tmp0_elvis_lhs_2 == null ? view_1 : tmp0_elvis_lhs_2;
          view_1.ebb(p_2, view_2);
          view_2.xbm(false);
          view_2.jbb(get_expanding(view_2), this.nia(view_2));
          view_2.jbb(get_expanding(view_2), this.hia(view_2));
          view_1.fbb(p_2, view_2);
          _this__u8e3s4.fbb(p_1, view_1);
          tmp = view_1;
        }
        return tmp;
      }
      ud6(_this__u8e3s4) {
        return this.lia(_this__u8e3s4, ($this$dialogCol) => {
          this.iia($this$dialogCol);
          this.jia($this$dialogCol);
          this.kia($this$dialogCol);
          var tmp0_safe_receiver = this.vim_1;
          if (tmp0_safe_receiver == null)
            null;
          else
            tmp0_safe_receiver($this$dialogCol);
          label2($this$dialogCol, 'Attachments', VOID, ($this$label2) => {
            shownDefaultFalse($this$label2, ($this$shownDefaultFalse) => {
              // Inline function 'kotlin.collections.isNotEmpty' call
              return !$this$shownDefaultFalse.baj(this.xim_1).i1();
            });
            return fileCarousel($this$label2, this.xim_1);
          });
          this.ci5($this$dialogCol);
          return Unit_instance;
        });
      }
    }
    initMetadataForClass($, 'TextAndFileInputDialog', VOID, VOID, VOID, [2]);
    TextAndFileInputDialogClass = $;
  }
  return TextAndFileInputDialogClass;
}
//region block: exports
export {
  BaseTextInputDialog as BaseTextInputDialog2ylbln5rtv3j3,
  Submission as Submission1tz7ozccph0bt,
  TextAndFileInputDialog as TextAndFileInputDialog30838dtq38cw5,
  TextInputDialog as TextInputDialog3qrlwab43tewg,
};
//endregion

//# sourceMappingURL=TextInputDialog.mjs.map
